import instance from './testing.instance';

export const getStaffResumen = () =>
    instance.get('/lector/staff/resumen/');

export const getStaffClientes = ({
    search = '',
    ordenar_por = 'facturas_total',
    ordenar_dir = 'desc',
    page = 1,
    page_size = 30,
} = {}) =>
    instance.get('/lector/staff/clientes/', {
        params: { search, ordenar_por, ordenar_dir, page, page_size },
    });

export const getStaffFacturas = ({
    cliente_id = '',
    tipo = '',
    proveedor = '',
    numero_factura = '',
    search = '',
    score_min = '',
    score_max = '',
    calidad = '',
    periodo_desde = '',
    periodo_hasta = '',
    fecha_recepcion_desde = '',
    fecha_recepcion_hasta = '',
    jerarquia_id = '',
    es_huerfana = '',
    estado = '',
    ordenar_por = 'score',
    ordenar_dir = 'asc',
    page = 1,
    page_size = 20,
} = {}) =>
    instance.get('/lector/staff/facturas/', {
        params: {
            cliente_id,
            tipo,
            proveedor,
            numero_factura,
            search,
            score_min,
            score_max,
            calidad,
            periodo_desde,
            periodo_hasta,
            fecha_recepcion_desde,
            fecha_recepcion_hasta,
            jerarquia_id,
            es_huerfana,
            estado,
            ordenar_por,
            ordenar_dir,
            page,
            page_size,
        },
    });

export const getStaffCostos = ({
    desde = '',
    hasta = '',
    tipo_servicio = '',
    cliente_id = '',
    jerarquia_id = '',
    estado = '',
    top = 10,
} = {}) =>
    instance.get('/lector/staff/costos/', {
        params: { desde, hasta, tipo_servicio, cliente_id, jerarquia_id, estado, top },
    });

export const getStaffVerificacion = ({ cliente_id = '' } = {}) =>
    instance.get('/lector/staff/verificacion/', {
        params: { cliente_id },
    });
